import script from "./HomeCTA.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCTA.vue?vue&type=script&setup=true&lang=js"

import "./HomeCTA.vue?vue&type=style&index=0&id=474ead1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474ead1e"]])

export default __exports__